import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Line, mixins as chartMixins } from "vue-chartjs";
// import "chartjs-plugin-colorschemes";

@Component({
    name: "line-chart",
})
export default class LineChart extends mixins(Line, chartMixins.reactiveProp) {
    @Prop()
    public chartData: Chart.ChartData;

    @Prop()
    public options: Chart.ChartOptions;

    @Watch("options", { deep: true })
    public onOptionsChanged(): void {
        this.renderChart(this.chartData, this.options);
    }

    public mounted(): void {
        this.renderChart(this.chartData, this.options);
    }
}
